import React from "react";
import DRONE_CONTROL_HAND from "../../../assets/v4-reports-assets/images/drone-control-hand.png";
import DRONE from "../../../assets/v4-reports-assets/icons/drone.png";
import LOGO_WHITE from "../../../assets/v4-reports-assets/images/logo-white.png";
import SPLASH_IMAGE from "../../../assets/v4-reports-assets/images/home-header.png";
import GEO_LOCATION from "../../../assets/v4-reports-assets/icons/geo-location.png";
// import HOME_FRONT from "../../../assets/v4-reports-assets/images/property-picture.png";
import "./styles.scss";

const Section1 = ({ address, homeFrontView }) => {
  return (
    <>
      {" "}
      <section class="index-section">
        <div class="container">
          <div class="site-logo">
            <img src={LOGO_WHITE} alt="" />
          </div>

          <div class="drone-hand">
            <img
              style={{
                transform: "scale(1.5) translateX(-1rem)",
              }}
              src={DRONE_CONTROL_HAND}
              alt=""
            />
          </div>

          <div
            style={{ transform: "translateY(5rem)" }}
            class="index-section__body"
          >
            <img src={SPLASH_IMAGE} alt="" class="index-section__body--image" />
            <div class="body-container">
              <div
                style={{
                  background: `url(${homeFrontView})`,

                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                class=" homeViewImage rotating-image"
              >
                {/* <img
                  src={homeFrontView}
                  alt=""
                  class="drone-image round-frontview"
                /> */}
              </div>
              <div>
                <div class="section-header-container">
                  <h1 class="section-header">
                    Drone Assessment Property Report
                  </h1>
                  <img src={DRONE} alt="" class="drone-image" />
                </div>

                <div class="site-address">
                  <img src={GEO_LOCATION} alt="" class="location-icon" />
                  <p style={{ marginTop: "15px" }} class="address-text">
                    {address}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Section1;
